import { isNil, omitBy } from 'lodash';

export const Endpoint = () => `/api/v3/search/aggregation/`;

export const QueryKey = (payload?: Payload) => ['v3', 'search', 'aggregation', omitBy(payload, isNil)] as const;

export type Payload = {
    termName: string;
    termValue: string;
};

export type Response = {
    bulletingAggregation: {
        high?: Record<number, number>;
        medium?: Record<number, number>;
        low?: Record<number, number>;
        zero?: Record<number, number>;
    };
};
